<template>
  <div class="personal-setting">
    <div class="content">
      <div class="title">下单设置</div>
      <div class="setting-item">
        <div>
          <span>是否开启云拆？</span>
          <el-switch
            v-model="splitMode"
            active-text="是"
            inactive-text="否"
            :active-value="1"
            :inactive-value="0"
          >
          </el-switch>
        </div>
        <div>
          <span>是否显示全量下载设置文件按钮？</span>
          <el-switch
            v-model="splitButton"
            active-text="是"
            inactive-text="否"
            :active-value="true"
            :inactive-value="false"
          >
          </el-switch>
        </div>
      </div>
    </div>

    <div class="footer">
      <el-button size="small" @click="handleCancel">取 消</el-button>
      <el-button size="small" type="primary" @click="handleConfirm"
        >确 定</el-button
      >
    </div>
  </div>
</template>

<script>
import { api } from "@/api/index";
import { Loading } from "element-ui";

export default {
  computed: {},
  data() {
    return {
      splitMode: 0,
      splitButton: false,
    };
  },
  methods: {
    async handleConfirm() {
      let loadingInstance = Loading.service();
      try {
        let params = {
          taskModel: this.splitMode,
          splitButton: this.splitButton ? 1 : 0,
        };
        let res = await api.order.createUserSetting(params);
        if (res.status) {
          sessionStorage.setItem("splitMode", this.splitMode);
          sessionStorage.setItem("splitButton", this.splitButton ? 1 : 0);
          this.setSessionItem("splitButton", this.splitButton ? 1 : 0);
          this.handleSave();
        }
      } catch (err) {
        console.log(err);
      } finally {
        loadingInstance.close();
      }
    },
    /**
     * 设置默认值
     */
    handleDefault() {
      this.splitMode = sessionStorage.getItem("splitMode") === "1" ? 1 : 0;
      this.splitButton =
        sessionStorage.getItem("splitButton") === "1" ? true : false;
    },
    /**
     * 取消
     */
    handleCancel() {
      this.$emit("cancel");
    },
    /**
     * 保存
     */
    handleSave() {
      this.$message.success("保存成功");
      this.$emit("save");
    },
    async queryUserSetting() {
      this.loading = true;
      try {
        let res = await api.order.queryUserSetting();
        this.loading = false;
        if (res.status) {
          sessionStorage.setItem(
            "splitMode",
            res.data && res.data.taskModel ? res.data.taskModel : "0",
          );
          this.setSessionItem(
            "splitButton",
            res.data && res.data.splitButton ? res.data.splitButton : "0",
          );
        }
      } catch (err) {
        this.loading = false;
        console.log(err, "创建个人设置");
      }
    },
  },
  async mounted() {
    await this.queryUserSetting();
    this.handleDefault();
  },
};
</script>

<style lang="scss">
.personal-setting {
  > .content {
    > .title {
      color: var(--color-primary);
      font-size: 16px;
      font-weight: bold;
      border-left: 4px solid var(--color-primary);
      padding-left: 5px;
    }
    > .setting-item {
      background-color: #f1f1f1;
      padding: 10px;
      line-height: 2.5em;
      margin: 10px 0;
    }
  }
  > .footer {
    padding-top: 10px;
    display: flex;
    justify-content: center;
    gap: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// personalSetting.vue?634416de